import { FormattedMessage, useIntl } from 'react-intl';
import React, { ReactNode } from 'react';

import { Modal, ResponsiveWidth } from '..';
import { IModalProps } from '..';
import { useStyles } from './offline-error-modal.styles';
import { Button } from '../button-new';

export const OfflineErrorModal = ({ onClose, ...props }: IModalProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const handleClose = () => {
    onClose!();
  };

  return (
    <Modal
      {...props}
      onClose={handleClose}
      data-testid="offline-error-modal"
      title={intl.formatMessage({ id: 'offline.title' }, { noBreak: <>&nbsp;</> })}
      titleStyles={classes.title}
      propsPaperStyles={classes.paper}
      content={
        <>
          <p data-testid="offline-error-content-1" className={classes.content}>
            {intl.formatMessage(
              { id: 'offline.text-1' },
              { noBreak: <>&nbsp;</>, sup: (chunk: ReactNode) => <sup>{chunk}</sup> },
            )}
          </p>
          <p data-testid="offline-error-content-2" className={classes.content}>
            {intl.formatMessage({ id: 'offline.text-2' }, { noBreak: <>&nbsp;</> })}
          </p>
          <div className={classes.footerButtons}>
            <Button
              style="dark"
              testId="call-button"
              aria-label={intl.formatMessage({ id: 'order.callSupport.modal.callButton.ariaLabel' })}
              to={intl.formatMessage({ id: 'common.phoneNumber.support.href' })}
            >
              <FormattedMessage id="common.errors.callSupport" />
            </Button>
            <Button
              style="outlined"
              onClick={handleClose}
              testId="get-button"
              aria-label={intl.formatMessage({ id: 'order.callSupport.modal.getButton.ariaLabel' })}
            >
              <FormattedMessage id="common.gotIt" />
            </Button>
          </div>
        </>
      }
      responsiveWidth={ResponsiveWidth.mdWider}
    />
  );
};
